/** Marks a gate rule as the company's own policy rather than external regulation. */
import { Badge } from '@/components/ui/badge';
import type { RuleSeverity, RuleSource } from '@/types/rules';

interface RuleSourceBadgeProps {
  source: RuleSource | undefined;
  severity: RuleSeverity;
}

export function RuleSourceBadge({ source, severity }: RuleSourceBadgeProps) {
  if (source !== 'internal_policy') return null;
  return (
    <Badge
      variant="outline"
      className="border-violet-500/30 bg-violet-500/10 text-[10px] text-violet-700 dark:text-violet-400"
      title={
        severity === 'info'
          ? 'Company policy rule. Advisory only at info severity.'
          : 'Company policy rule. A breach can only be approved by a senior reviewer.'
      }
    >
      Internal policy
    </Badge>
  );
}
